import { ThunkAction, Dispatch } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import {
    SegmentBoardEvent,
    SegmentCardEvent,
    SegmentListEvent,
    segmentTrackAction
} from '../../../../../../../middlewares/segment';
import { entityPanelWidthSetAction } from '../../../store/actions/entityPanelWidthSetAction';
import { vent } from 'app/store/constants';
import { EAsidePanelViewType } from '../types';

export const onResized = (
    width: number,
    panelType?: EAsidePanelViewType
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        localStorage.setItem('asidePanelWidth', String(width));
        if (panelType) {
            if (panelType === EAsidePanelViewType.BOARD) {
                dispatch(segmentTrackAction(SegmentBoardEvent.ASIDE_PANEL_RESIZED, {
                    name: panelType,
                    value: width
                }));
            } else if (panelType === EAsidePanelViewType.LIST || panelType === EAsidePanelViewType.MULTI_LIST) {
                dispatch(segmentTrackAction(SegmentListEvent.ASIDE_PANEL_RESIZED, {
                    name: panelType,
                    value: width
                }));
            } else {
                dispatch(segmentTrackAction(SegmentCardEvent.ASIDE_PANEL_RESIZED, {
                    name: panelType,
                    value: width
                }));
            }
        }
        dispatch(entityPanelWidthSetAction(width));
        requestAnimationFrame(() => {
            vent.trigger(vent['view:resized']); // to setPanelsWidth
        });
    };
    return action;
};
